import { type PanelRow } from '../../payload/panels'
import { n, num, pct, s } from '../format'

type FunnelProps = {
  rows: PanelRow[]
  valueKey: string
  labelKey: string
  /** A second population shown beside each step, never added in. */
  compare?: { key: string; label: string }
}

/** Nested steps, each a strict subset of the one above — a genuine funnel. */
const Funnel = ({ rows, valueKey, labelKey, compare }: FunnelProps) => {
  const max = Math.max(1, ...rows.map(r => n(r[valueKey])))

  return (
    <div className="grid gap-2.5">
      {rows.map((row, i) => {
        const value = n(row[valueKey])
        const prev = i ? n(rows[i - 1][valueKey]) : null
        return (
          <div key={s(row[labelKey])} className="grid gap-1">
            <div className="flex justify-between gap-2">
              <span className="text-sm">{s(row[labelKey])}</span>
              <span className="text-right text-sm whitespace-nowrap tabular-nums">
                <strong>{num(value)}</strong>
                {prev !== null && (
                  <span className="text-muted text-xs">
                    {` ${pct(value, prev)} of the step above`}
                  </span>
                )}
                {compare && (
                  <span className="text-muted block text-xs">
                    {`${num(row[compare.key])} ${compare.label}`}
                  </span>
                )}
              </span>
            </div>
            <div className="bg-surface-secondary h-2.5 rounded-sm">
              <div
                className="bg-accent h-full rounded-sm"
                style={{ width: `${(value / max) * 100}%` }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Funnel
